export default __webpack_public_path__ + "static/media/precise-location-ss-unselected.6ba78531.svg";